import React from "react";

const ThirdParty = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        J.
        <span className="text-[#01A7D1] ">
          {" "}
          THIRD-PARTY LINKS, CONTACT FORMS AND PHONE NUMBERS
        </span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        The Platform may provide, or third parties may provide, links, contact
        forms and/or phone numbers to other Platforms or resources, including,
        without limitation, social networking, blogging and similar Platforms
        through which you are able to log into the Platform using your existing
        account and log-in credentials for such third-party Platforms. Certain
        areas of the Platform may allow you to interact and/or conduct
        transactions with such third-party sites, and, if applicable, allow you
        to configure your privacy settings in your third-party site account to
        permit your activities on the Platform to be shared with your contacts
        in your third-party site account. Because Yostel has no control over
        such sites and resources, you acknowledge and agree that Yostel is not
        responsible for the availability of such external sites or resources,
        and is not responsible or liable for any content, advertising, products,
        goods or services on or available from such Platforms or resources.
        Unless expressly stated on the Platform, links to third-party sites
        should in no way be considered as or interpreted to be Yostel's
        endorsement of such third-party sites or any product or service offered
        through them.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You further acknowledge and agree that Yostel shall not be responsible
        or liable, directly or indirectly, for any damage or loss caused or
        alleged to be caused by or in connection with use of or reliance on any
        such content, advertising, product, goods or services available on or
        through any such Platform or resource. The Third-party Platform may have
        different privacy policies and terms and conditions and business
        practices than Yostel. In certain situations, you may be transferred to
        a third-party Platform through a link or connected to a third-party
        resource by a contact form or phone, but it may appear that you are
        still on this Platform or transacting with Yostel. In these situations,
        you acknowledge and agree that the third-party Platform terms and
        conditions and privacy policy apply in this situation. Your dealings and
        communications through the Platform with any party other than Yostel are
        solely between you and such third parties. Any complaints, concerns or
        questions you have relating to materials provided by third parties
        should be forwarded directly to the applicable third party.
      </p>
    </div>
  );
};

export default ThirdParty;
